import React, {useEffect, useState} from 'react';
import {Button, Modal, Select} from "react-materialize";
import TBInput from "../Commons/Input.react";

const SettingsModal = ({open, handleClose, primaryLabel=''}) => {

  // useEffect(() => {
  //   console.log('type =>', open)
  //   // if (type !== false) {
  //   //   setOpen(true);
  //   // }
  //
  // }, [open])

  return (
    <Modal
      open={open}
      options={{
        onCloseEnd: () => { handleClose()},
      }}
      actions={[
        <Button onClick={handleClose} flat modal={'close'} node={'button'} waves={'red'}>Cancel</Button>,
        <Button onClick={handleClose} flat modal={'close'} node={'button'} waves={'green'}>Create {primaryLabel}</Button>
      ]}
      header={`Create ${primaryLabel}`}
    >
      <div>
        <TBInput name={'role'} label={'Name'} />
        <TBInput name={'role'} label={'Description'} />
        <Select>
          <option>permission</option>
          <option>permission</option>
          <option>permission</option>
          <option>permission</option>
        </Select>
      </div>
    </Modal>
  )
}

export default SettingsModal;